import type { MyBridgeAgentConversationRow } from '@common/reducers/backend-api/backend-api';

export type TakeoverSource = MyBridgeAgentConversationRow['takeover']['source'];

/**
 * The i18n key of a held conversation's "since" line, by takeover source.
 *  - `auto`   the owner wrote in the chat (automatic takeover);
 *  - `manual` / null / anything unknown → manual.
 */
export const takeoverSinceKey = (source: TakeoverSource | string | undefined): string =>
  source === 'auto' ? 'myBridge.conversations.sinceAuto' : 'myBridge.conversations.sinceManual';
